enum FileType {
  image = "image",
  audio = "audio"
}

export default FileType;
